import {
  Component,
  Input,
  OnInit,
  HostListener,
  forwardRef,
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelectOption } from './interfaces/multi-select-opts';
@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true,
    },
  ],
})
export class MultiSelectComponent {
  @Input() formControl!: FormControl<string[] | null>;
  @Input() options: MultiSelectOption[] = [];
  @Input() placeholder = 'Selecciona opciones...';
  @Input() disabled = false;
  value: string[] = [];
  isOpen = false;

  /** Métodos del ControlValueAccessor */
  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  // 🔹 Angular llama a esto cuando cambia el valor desde afuera
  writeValue(value: string[] | null): void {
    this.value = value || [];
  }

  // 🔹 Angular te da una función para avisarle de los cambios
  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  // 🔹 Angular te da una función para avisarle de los "toques" (blur)
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // 🔹 Angular puede llamarte para deshabilitar el control
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /** Devuelve las opciones seleccionadas */
  get selectedOptions(): MultiSelectOption[] {
    const values = this.formControl.value || [];
    return this.options.filter((opt) => values.includes(opt.valueId));
  }

  toggleDropdown() {
    if (this.disabled) return;
    this.isOpen = !this.isOpen;
  }

  toggleSelection(option: MultiSelectOption) {
    const current = this.formControl.value || [];
    if (current.includes(option.valueId)) {
      this.formControl.setValue(current.filter((v) => v !== option.valueId));
    } else {
      this.formControl.setValue([...current, option.valueId]);
    }
    this.formControl.markAsTouched();
  }

  isSelected(option: MultiSelectOption): boolean {
    return this.formControl.value?.includes(option.valueId) ?? false;
  }

  removeOption(option: MultiSelectOption) {
    const updated =
      this.formControl.value?.filter((v) => v !== option.valueId) || [];
    this.formControl.setValue(updated);
  }

  /** Cierra el dropdown al hacer clic fuera del componente */
  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.multi-select-container')) {
      this.isOpen = false;
    }
  }
}
